import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["signerInput", "total", "paymentReadyBtn", "saveBtn", "saveStatus"]

  connect() {
    this.dirty = false
    this.recalculate()
  }

  inputChanged(event) {
    this.dirty = true
    if (this.hasSaveStatusTarget) this.saveStatusTarget.innerHTML = ""
    this.updateLineTotal(event.target)
    this.recalculate()
    this.syncButtons()
  }

  markClean() {
    this.dirty = false
    this.syncButtons()
  }

  updateLineTotal(input) {
    const row = input.closest("[data-doc-row]")
    if (!row) return
    const priceEl = row.querySelector("[data-line-price]")
    if (!priceEl) return
    priceEl.textContent = `$${(parseInt(input.value) || 0) * 25}`
  }

  recalculate() {
    const total = this.signerInputTargets.reduce(
      (sum, input) => sum + (parseInt(input.value) || 0) * 25, 0
    )
    if (this.hasTotalTarget) {
      this.totalTarget.textContent = `$${total}.00`
    }
  }

  syncButtons() {
    if (this.hasPaymentReadyBtnTarget) {
      this.paymentReadyBtnTarget.disabled = this.dirty
      this.paymentReadyBtnTarget.title = this.dirty ? "Save documents before proceeding" : ""
    }
    if (this.hasSaveBtnTarget) {
      this.saveBtnTarget.classList.toggle("btn-outline-secondary", !this.dirty)
      this.saveBtnTarget.classList.toggle("btn-warning", this.dirty)
    }
  }
}
